import { useState, useEffect } from "react";
import HeaderBar from "./HeaderBar/HeaderBar";
import InfoPanel from "./InfoPanel";
import Login from "./Login/Login";
import HiTrustLogo from "../../assets/images/HITRUSTCSFCertifiedLogo_white.png";
import PoweredByAWS from "../../assets/images/poweredby-aws.png";
import { getDomainFromUrl } from "../../utils/domainUtilities";

const Home = () => {
  const currentYear = new Date().getFullYear();
  const [domainBox, setDomainBox] = useState(null);

  useEffect(() => {
    const initializeHome = async () => {
      try {
        const customHome = await import(
          "../../custom_portal/" + getDomainFromUrl(window.location.hostname) + "/components/home/home"
        );

        const { Home } = await customHome;
        setDomainBox(<Home />);
      } catch {
        setDomainBox(DefaultBox);
      }
    };
    initializeHome();
  }, []);

  const DefaultBox = (
    <div>
      <HeaderBar />
      <a href="#sesMainContentWrapper" className="sr-only sr-only-focusable">
        Skip to main content
      </a>
      <main id="sesMainContentWrapper" className="animate slide delay-4">
        <Login />
        <article aria-label="About Direct Email">
          {/*<section className="alert alert-warning sp-mx4 shade-3 dg-clr">*/}
          {/*    <b>SCHEDULED MAINTENANCE:</b> On [ Friday, May 30th at 9pm ] we will perform maintenance that will cause the portal and webmail application to be unavailable for approximately [ 4 ] hours. If you have any questions regarding this maintenance, please contact support.*/}
          {/*</section>*/}
          <section className="ses-text-container" aria-labelledby="whyDirectHeading">
            <div className="main-whyhow-text animate slide delay-5">
              <h1 className="main-whyhow-title" id="whyDirectHeading">Why Direct?</h1>
              <hr />
              <p>
                    Direct Mail provides healthcare professionals the ability to
                    communicate securely with their colleagues and patients. We
                    enable healthcare professionals to maintain HIPAA compliance
                    when sending and receiving encrypted health information over
                    email.
              </p>
              <p>
                  We work with physicians to ensure that our product is
                  user-friendly and fits easily into your current workflow. Our
                  exclusive technology integrates seamlessly with any EHR, patient
                  management and email system, allowing you to start communicating
                  immediately.
              </p>
            </div>
          </section>
          <section className="ses-news-container" aria-labelledby="whatWeDoHeading">
            <div className="news-content animate slide delay-6">
              <h1 className="news-header" id="whatWeDoHeading">What we do...</h1>
              <hr />
              <p>
                The ability to communicate electronically with patients, labs,
                hospitals and other providers is crucial for patient
                satisfaction and quality of care. The functionality provided by
                this technology is key to simple, secure communications that
                work within your existing workflow. Our solution provides a
                secure way for healthcare professionals to send and receive
                encrypted health information over the Internet.
              </p>
              {/* Change for Custom Branding */}
              <h2 className="sp-margin10">Technical Support</h2>
              <p className="sp-mx7">
                Phone:{" "}
                <a href="tel:18884709913" aria-label="Call technical support at 1-888-470-9913">
                  888-470-9913
                </a>
              </p>
              <p>
                Email:{" "}
                <a
                  href="mailto:support@secureexsolutions.com"
                  aria-label="Email technical support at support@secureexsolutions.com"
                >
                  support@secureexsolutions.com
                </a>
              </p>
            </div>
          </section>
        </article>
      </main>
      <InfoPanel />
      <div className="ses_footer">
        <div className="ses-footer animate slide delay-2">
          <footer role="contentinfo">
            <div className="ses-footer-container">
              <div
                className="ses-directTrust"
                role="img"
                aria-label="Direct Trust Certification DTAAP HISP DTAAP CA DTAAP RA"
              ></div>
            </div>

            <div className="right-container">
              <div className="poweredby-aws">
                <a
                  href="http://hitrustalliance.net"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={HiTrustLogo}
                    className="hitrust-img"
                    alt="HITRUST CSF Certified"
                  />
                </a>
                <span className="sr-only">(opens in a new tab)</span>
                <img
                  src={PoweredByAWS}
                  alt="Powered by AWS"
                />
              </div>

              <div className="contact-footer">
                <strong>Technical Support:</strong> <a href="tel:18884709913" aria-label="Call technical support at 1-888-470-9913">1.888.470.9913</a> |{" "}
                <a 
                    href="mailto:support@secureexsolutions.com"
                    aria-label="Email technical support at support@secureexsolutions.com"
                >
                  support@secureexsolutions.com
                </a>
              </div>
              <div className="copyright">
                  Copyright &copy; {currentYear}{" "} 
                  <span aria-hidden="true">|</span>{" "} 
                  <a href="https://www.centaurihs.com/" target="_blank" rel="noreferrer" > 
                    Centauri Health Solutions 
                    <span className="sr-only">(opens in a new tab)</span>
                  </a>{" "}
                  <span aria-hidden="true">|</span>{" "} 
                  Powered by CHS Direct{" "} 
                  <span aria-hidden="true">|</span>{" "}
                  <a 
                    href="https://www.centaurihs.com/privacy-policy/" 
                    target="_blank" 
                    rel="noreferrer"
                  > Privacy 
                  <span className="sr-only">(opens in a new tab)</span>
                  </a>{" "}
                <span aria-hidden="true">|</span>{" "}
                <a 
                  href="https://www.centaurihs.com/terms-of-use/" 
                  target="_blank" 
                  rel="noreferrer noopener" >
                    Terms of Use
                    <span className="sr-only">(opens in a new tab)</span>
                 </a>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );

  return <div>{domainBox}</div>;
};

export default Home;
